import PieChartIcon from '@mui/icons-material/PieChart';
import BookIcon from '@mui/icons-material/Book';
import TaskIcon from '@mui/icons-material/Task';
import BadgeIcon from '@mui/icons-material/Badge';
import ConstructionIcon from '@mui/icons-material/Construction';
import GroupsIcon from '@mui/icons-material/Groups';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsIcon from '@mui/icons-material/Settings';
import DeviceUnknownIcon from '@mui/icons-material/DeviceUnknown';
import DomainIcon from '@mui/icons-material/Domain';
import DoNotDisturbOffIcon from '@mui/icons-material/DoNotDisturbOff';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';

import {IMenuItem} from './types/menu.types';
import {TypeAccountRoles} from './types/user-account.types';

export const firstMenu: IMenuItem[] = [
  {
    link: '/',
    title: 'Главная',
    Icon: PieChartIcon,
    forRoles: [
      TypeAccountRoles.OWNER,
      TypeAccountRoles.ADMIN,
      TypeAccountRoles.FUNCTIONAL_ADMIN,
      TypeAccountRoles.DIRECTOR,
      TypeAccountRoles.PROJECT_MANAGER,
      TypeAccountRoles.MANAGER,
    ],
  },
  {
    link: '/serviceRequests',
    title: 'Заявки',
    Icon: BookIcon,
  },
  {
    link: '/contracts',
    title: 'Контракты',
    Icon: TaskIcon,
    forRoles: [
      TypeAccountRoles.OWNER,
      TypeAccountRoles.ADMIN,
      TypeAccountRoles.FUNCTIONAL_ADMIN,
      TypeAccountRoles.DIRECTOR,
      TypeAccountRoles.PROJECT_MANAGER,
      TypeAccountRoles.MANAGER,
    ],
  },
  {
    link: '/users',
    title: 'Пользователи',
    Icon: BadgeIcon,
    forRoles: [
      TypeAccountRoles.OWNER,
      TypeAccountRoles.ADMIN,
      TypeAccountRoles.FUNCTIONAL_ADMIN,
      TypeAccountRoles.DIRECTOR,
      TypeAccountRoles.PROJECT_MANAGER,
      TypeAccountRoles.MANAGER,
    ],
  },
  {
    link: '/customers',
    title: 'Заказчики',
    Icon: GroupsIcon,
    forRoles: [
      TypeAccountRoles.OWNER,
      TypeAccountRoles.ADMIN,
      TypeAccountRoles.FUNCTIONAL_ADMIN,
      TypeAccountRoles.DIRECTOR,
      TypeAccountRoles.PROJECT_MANAGER,
      TypeAccountRoles.MANAGER,
    ],
  },
  {
    link: '/reports',
    title: 'Отчеты',
    Icon: AssessmentIcon,
    forRoles: [
      TypeAccountRoles.OWNER,
      TypeAccountRoles.ADMIN,
      TypeAccountRoles.FUNCTIONAL_ADMIN,
      TypeAccountRoles.DIRECTOR,
      TypeAccountRoles.PROJECT_MANAGER,
      TypeAccountRoles.MANAGER,
    ],
  },
];

export const secondMenu: IMenuItem[] = [
  {
    link: '/settings',
    title: 'Настройки',
    Icon: SettingsIcon,
    forRoles: [
      TypeAccountRoles.OWNER,
      TypeAccountRoles.ADMIN,
      TypeAccountRoles.FUNCTIONAL_ADMIN,
      TypeAccountRoles.DIRECTOR,
      TypeAccountRoles.PROJECT_MANAGER,
      TypeAccountRoles.MANAGER,
    ],
  },
  {
    link: '/dictionaries',
    title: 'Справочники',
    Icon: ConstructionIcon,
    forRoles: [TypeAccountRoles.OWNER, TypeAccountRoles.ADMIN, TypeAccountRoles.FUNCTIONAL_ADMIN],
  },
];

export const dictionaries: IMenuItem[] = [
  {
    link: '/dictionaries/deviceTypes',
    title: 'Виды работ',
    Icon: DeviceUnknownIcon,
  },
  {
    link: '/dictionaries/taskLocations',
    title: 'Места установки',
    Icon: DomainIcon,
  },
  {
    link: '/dictionaries/reasonRejections',
    title: 'Причины отмены',
    Icon: DoNotDisturbOffIcon,
  },
  {
    link: '/dictionaries/deviceModels',
    title: 'Модели устройств',
    Icon: SettingsRemoteIcon,
  },
  {
    link: '/dictionaries/devices',
    title: 'Устройства',
    Icon: DeviceHubIcon,
  },
];

export const location: Record<string, string> = {
  '/': 'Главная',
  '/serviceRequests': 'Заявки',
  '/serviceRequests/new': 'Создание заявки',
  '/serviceRequests/assign': 'Назначение заявок',
  '/contracts': 'Контракты',
  '/contracts/addContract': 'Добавление контракта',
  '/users': 'Пользователи',
  '/customers': 'Заказчики',
  '/customers/addCompany': 'Добавление заказчика',
  '/reports': 'Отчеты',
  '/reports/executed': 'Отчет по заявкам',
  '/reports/universal': 'Универсальный отчет',
  '/reports/forma': 'Форма выработки перечней',
  '/reports/delay': 'Реестр актов недопуска',
  '/reports/masterCounter': 'Отчет по мастер счетчикам',
  '/settings': 'Настройки',
  '/settings/importDevices': 'Импорт устройств',
  '/dictionaries': 'Справочники',
  '/dictionaries/deviceTypes': 'Виды работ',
  '/dictionaries/deviceModels': 'Модели устройств',
  '/dictionaries/devices': 'Справочник устройств',
  '/dictionaries/taskLocations': 'Места установки',
  '/dictionaries/reasonRejections': 'Причины отмены заявки',
};

export const subLocation: Record<string, string> = {
  '/contracts': 'Описание контракта',
  '/customers': 'Описание компании',
  '/serviceRequests': 'Описание заявки',
  '/dictionaries/deviceTypes': 'Описание вида работ',
  '/dictionaries/taskLocations': 'Описание места установки',
  '/dictionaries/reasonRejection': 'Описание причины отмены',
  '/reports': 'Отчеты',
};
